import React from 'react';

import { CustomIcon } from 'shared/components/CustomIcon';
import { useAppContext } from 'Main';

const SettingsToggle = () => {
  const { setConfig } = useAppContext();

  const handleClick = () => {
    setConfig('showSettingPanel', true);
  };

  return (
    <div
      role="button"
      className="d-flex align-items-center mb-2"
      onClick={handleClick}
    >
      <CustomIcon icon="palette" size={24} />

      <small className="nav-link nav-link-text ps-1 position-relative fw-semibold">
        Customize
      </small>
    </div>
  );
};

export default SettingsToggle;
